import React, { ReactNode } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { StoreProvider } from 'easy-peasy';
import theme from 'app/theme';
import { BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, StylesProvider } from '@material-ui/core';
import { RecoilRoot } from 'recoil';
import { store } from 'app/state/store';
import { Auth0Provider } from '@auth0/auth0-react';
import { AuthProvider as AsgardeoAuthProvider } from '@asgardeo/auth-react';

type ProviderProps = {
  children?: ReactNode;
};

const ASGARDEO_CONFIG = {
  signInRedirectURL: `https://${window.location.host}/oidc/callback`,
  signOutRedirectURL: `https://${window.location.host}/oidc/callback`,
  clientID: process.env.REACT_APP_ASGARDEO_CLIENT_ID,
  baseUrl: process.env.REACT_APP_ASGARDEO_BASE_URL,
  scope: [
    'ryd',
    'openid',
    'profile',
    'ryd:dataset',
    'ryd:reporting_org',
    'ryd:dataset:delete',
    'ryd:dataset:update',
  ],
};

function Providers(props: ProviderProps) {
  return (
    <RecoilRoot>
      <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <StoreProvider store={store}>
            <Auth0Provider
              redirectUri={`${window.location.origin}/callback`}
              domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
              clientId={process.env.REACT_APP_AUTH0_CLIENT as string}
              audience={process.env.REACT_APP_AUTH0_AUDIENCE as string}
            >
              {/* @ts-ignore */}
              <AsgardeoAuthProvider config={ASGARDEO_CONFIG}>
                <Router>{props.children}</Router>
              </AsgardeoAuthProvider>
            </Auth0Provider>
          </StoreProvider>
        </ThemeProvider>
      </StylesProvider>
    </RecoilRoot>
  );
}

export default Providers;
